module.exports = __webpack_public_path__ + "img/domain-01.35dec00b.png";